import { Nullable } from '$models'
import { StaffMember } from './staffMember'
import {
  StaffMemberAu,
  transformStaffMemberAuOnGet,
  transformStaffMemberAuOnSave,
} from './staffMemberAu'

export interface StaffMemberXeroAu extends StaffMemberAu {
  calendarId: Nullable<string>
  ordinaryEarningsRateId: Nullable<string>
}

// Function to apply transformations to StaffMemberXeroAu object on get
export const transformStaffMemberXeroAuOnGet = (
  staffMember: StaffMember
): StaffMemberXeroAu => {
  const transformedStaffMember = transformStaffMemberAuOnGet(
    staffMember
  ) as StaffMemberXeroAu

  return transformedStaffMember
}

// Function to apply transformations to StaffMemberXeroAu object on get
export const transformStaffMemberXeroAuOnSave = (
  staffMember: StaffMember
): object => {
  const staffMemberXeroAU = staffMember as unknown as StaffMemberXeroAu
  const transformedStaffMember = transformStaffMemberAuOnSave(staffMember)

  return {
    ...transformedStaffMember,
    calendar: staffMemberXeroAU.calendarId,
    ordinaryEarningsRate: staffMemberXeroAU.ordinaryEarningsRateId,
  }
}
